'use client'

import Link from 'next/link'
import { memo } from 'react'
import { useFeatureFlag } from '@dustin-web/microsite-data/src/feature-flags/client'
import {
  useAccordionScroll,
  openAccordionItem,
} from '@dustin-web/microsite-components/src/accordion-group'

import { ACCORDION_AB_TEST_FLAG } from '../../../product-page.constants'

import './product-specifications.scss'

type Props = {
  title: string
  pathname: string
  linkText: string
  specifications: { name: string; value: string }[]
}

const ITEM_VALUE = 'specification'

const ProductSpecifications = ({ title, pathname, linkText, specifications }: Props) => {
  const { enabled: accordionsEnabled } = useFeatureFlag(ACCORDION_AB_TEST_FLAG)
  const { scrollToItem } = useAccordionScroll()

  const allSpecificationsLink = `${pathname}?tab=${ITEM_VALUE}&scrollToTab=true`
  const maxSpecificationsToShow = 9

  const handleAccordionClick = () => {
    openAccordionItem(ITEM_VALUE)
    scrollToItem(ITEM_VALUE)
  }

  return (
    <section className="product-specifications">
      <h2 className="h4">{title}</h2>
      <table data-testid="product-specifications-table">
        <tbody>
          {specifications?.slice(0, maxSpecificationsToShow).map(({ name, value }, index) => (
            <tr key={index} data-testid={`product-specification-row-${index}`}>
              <td className="spec-name">{name}</td>
              <td className="spec-value">{value}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {accordionsEnabled ? (
        <button
          type="button"
          className="button-stripped"
          onClick={handleAccordionClick}
          data-testid="product-specifications-view-all-link">
          {linkText}
        </button>
      ) : (
        <Link
          data-testid="product-specifications-view-all-link"
          scroll={false}
          href={allSpecificationsLink}>
          {linkText}
        </Link>
      )}
    </section>
  )
}

export default memo(ProductSpecifications)
